document.addEventListener("DOMContentLoaded", () => {
    var variant_text = $('.variant-container ul').find('.active a').text().trim()

    $('.type-data-1').each(function() {
        var text = $(this).text().trim()

        if(variant_text.includes(text)) {
            $(this).parents('.air-type-item').css('color', '#1572dd')
            $(this).parents('.air-type-item').css('font-weight', '500')
        }
    })
});